"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEMP_STYLES = exports.TEMPLATE = exports.DEFAULT_SHIMMER_SSREXPERIENCE = exports.BREAKPOINTS = void 0;

var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaClassic/theme"));

var DEFAULT_SHIMMER_SSREXPERIENCE = {
  CARDS: 1,
  BORDER_RADIUS: _theme.default.borderRadius.normal
};
exports.DEFAULT_SHIMMER_SSREXPERIENCE = DEFAULT_SHIMMER_SSREXPERIENCE;
var BREAKPOINTS = {
  MOBILE: '599px',
  SMALL_TABLET: '600px',
  MEDIUM_TABLET: '720px',
  LARGE_TABLET: '840px',
  DESKTOP: '1280px'
};
exports.BREAKPOINTS = BREAKPOINTS;
var TEMPLATE = {
  SSR: 'shimmer-meal-card',
  DROPDOWN: 'shimmer-dropdown'
};
exports.TEMPLATE = TEMPLATE;
var TEMP_STYLES = {
  DROPDOWN: {
    HEIGHT: '8px',
    WIDTH: ['90%', '40%'],
    BOTTOM_HEIGHT: '8px'
  },
  DEFAULT: {
    HEIGHT: '80px',
    WIDTH: ['50%', '30%', '60%', '40%'],
    BOTTOM_WIDTH: '150px',
    BOTTOM_HEIGHT: '50px',
    IMAGE_WIDTH: '80px'
  }
};
exports.TEMP_STYLES = TEMP_STYLES;